module.exports = __webpack_public_path__ + "img/access1.c1740cf0.png";